import axios from "utils/axios";
import { routes } from "api/routes";

export const apiGetLogsByUser = async (options) => {
  const { data } = await axios.post(routes.getLogsByUser, options);
  return data;
};

export const apiSearchUser = async (params) => {
  const { data } = await axios.get(routes.searchUser, { params });
  return data;
};

export const apiDeleteUser = async (userId) => {
  const { data } = await axios.delete(routes.deleteUser, {
    params: { userId },
  });
  return data;
};

export const apiResetUserPassword = async (formData) => {
  const { data } = await axios.post(routes.resetUserPassword, formData);
  return data;
};

export const apiToggleBanUser = async (formData) => {
  const { data } = await axios.post(routes.toggleBanUser, formData);
  return data;
};

export const apiRevokeUserToken = async (formData) => {
  const { data } = await axios.post(routes.revokeToken, formData);
  return data;
};

export const apiInviteUser = async (formData) => {
  const { data } = await axios.post(routes.inviteUser, formData);
  return data;
};

export const apiGetUserDetailsById = async (userId) => {
  const { data } = await axios.get(routes.getUserDetailsById, {
    params: { userId },
  });
  return data;
};

export const apiGetOnlineUserActivity = async (userId) => {
  const { data } = await axios.get(routes.getOnlineUserActvity, {
    params: { userId },
  });
  return data;
};

export const apiSearchTrades = async (formData) => {
  const { data } = await axios.post(routes.searchTrades, formData);
  return data;
};

export const apiEditTrade = async (formData) => {
  const { data } = await axios.put(routes.editTrade, formData);
  return data;
};

export const apiDeleteTrade = async (tradeId) => {
  const { data } = await axios.delete(routes.deleteTrade, {
    params: { tradeId },
  });
  return data;
};

/**
 * Get server connections list to detect foreign connections
 */
export const apiGetServerConnectionsList = async () => {
  const { data } = await axios.get(routes.getConnectionToServer);
  return data;
};

export const apiEnableAutomation = async (formData) => {
  const { data } = await axios.put(routes.enableAutomation, formData);
  return data;
};

export const apiDisableAutomation = async (formData) => {
  const { data } = await axios.put(routes.disableAutomation, formData);
  return data;
};

export const apiIssueAutomationToken = async (formData) => {
  const { data } = await axios.post(routes.issueAutomationToken, formData);
  return data;
};

export const apiRevokeAutomationToken = async (formData) => {
  const { data } = await axios.post(routes.revokeAutomationToken, formData);
  return data;
};

// unused !
// export const apiToggleAutomationHosting = async (formData) => {
//   const { data } = await axios.put(routes.toggleAutomationHosting, formData);
//   return data;
// };

export const apiFetchRecentTasks = async () => {
  const { data } = await axios.get(routes.fetchRecentTasks);
  return data;
};

export const apiFetchTaskLogs = async (taskId) => {
  const { data } = await axios.get(routes.fetchTaskLogs, {
    params: { taskId },
  });
  return data;
};

export const apiGetAvailableTasks = async () => {
  const { data } = await axios.get(routes.getAvailableTasks);
  return data;
};

export const apiTriggerAutomationTask = async (taskType) => {
  const { data } = await axios.post(routes.triggerAutomationTask, { taskType });
  return data;
};

// Splits tool
export const apiGetPriceAdjustments = async () => {
  const { data } = await axios.get(routes.priceAdjustments);
  return data;
};

export const apiScanPriceAdjustments = async () => {
  const { data } = await axios.post(routes.scanPriceAdjustments);
  return data;
};

// ratios: { record id: new shares per old share }; effectiveDates: { record
// id: "YYYY-MM-DD" first day in the new prices }
export const apiPreviewPriceAdjustmentFix = async (
  symbol,
  ratios = {},
  effectiveDates = {},
) => {
  const { data } = await axios.get(routes.previewPriceAdjustmentFix, {
    params: {
      symbol,
      ratios: JSON.stringify(ratios),
      effectiveDates: JSON.stringify(effectiveDates),
    },
  });
  return data;
};

export const apiFixPriceAdjustment = async (
  symbol,
  runDaily,
  ratios = {},
  effectiveDates = {},
) => {
  const { data } = await axios.post(routes.fixPriceAdjustment, {
    symbol,
    runDaily,
    ratios,
    effectiveDates,
  });
  return data;
};

export const apiDismissPriceAdjustment = async (id) => {
  const { data } = await axios.post(routes.dismissPriceAdjustment, { id });
  return data;
};

export const apiGetAdminFillQuality = async (days) => {
  const { data } = await axios.get(routes.adminFillQuality, { params: { days } });
  return data;
};
